import { useState } from 'react';

import type { TView } from '@shared/types/view';
import type { ColumnOrderState, Updater } from '@tanstack/react-table';

export const useColumnOrder = (view?: TView) => {
  const [columnOrder, setColumnOrder] = useState(
    view?.visible_static_fields.ordering || []
  );
  const derivedColumnOrder = columnOrder?.length
    ? columnOrder
    : view?.visible_static_fields.ordering || [];

  function onColumnOrderChange(colFnOrValue: Updater<ColumnOrderState>) {
    const cols =
      typeof colFnOrValue === 'function'
        ? colFnOrValue(derivedColumnOrder)
        : colFnOrValue;
    setColumnOrder(cols);
  }

  return {
    columnOrder: derivedColumnOrder,
    onColumnOrderChange,
  };
};
